import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { EstimatesKpiDashboard } from './components/EstimatesKpiDashboard';
import { EstimatesModulesGrid } from './components/EstimatesModulesGrid';
import { RecentEstimateActivity } from './components/RecentEstimateActivity';

export function EstimatesDashboardPage() {
  return (
    <PageLayout
      title="Dự toán & Báo giá"
      description="Trung tâm lập dự toán, định mức, tính toán chi phí và phân tích biên lợi nhuận công trình"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <EstimatesKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Nghiệp vụ Dự toán (Estimating Operations)
              </h3>
            </div>
            <div className="flex-1">
              <EstimatesModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động mới nhất
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentEstimateActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default EstimatesDashboardPage;
